import update from "immutability-helper";
import {ModelPipelineSettingAction,ModelPipelineSettingState} from "./ModelPipelineInterFace";

const initialState = {
	status: false,
	configs: {},
	setting: {},
	settingGenerator: null,
	id:"",
	is_confirmed: false,
};

const ModelPipelineReducer = (state: ModelPipelineSettingState = initialState, action: ModelPipelineSettingAction) => {

	switch (action.type) {
		case "SET_SETTING": {
			return {
				...action.payload,
			};
		}
		case "SET_SETTING_CLOSE":
			return {
				...state,status:false
			}
		case "SET_SETTING_CLOSE_AND_CONFIRM":
			return {
				...state,status:false,is_confirmed:true,configs:action.payload
			}
		default:
			return state;
	}
};

export default ModelPipelineReducer;
